import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useId } from 'react';
import { Title as Title$2, TitleLink } from './Title.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var _excluded = ["className", "children", "clickable", "onClick", "titleLinkProps", "url", "headingLevel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Title = function Title(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    children = _ref.children;
    _ref.clickable;
    var onClick = _ref.onClick,
    titleLinkProps = _ref.titleLinkProps,
    url = _ref.url,
    headingLevel = _ref.headingLevel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var headingId = useId();
  var isButton = onClick && !url;
  var headingTag = headingLevel ? "h".concat(headingLevel) : null;
  if (isButton && headingLevel) {
    return /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Title$2, {
        as: headingTag,
        id: headingId,
        className: "sr-only",
        children: children
      }), /*#__PURE__*/jsx(TitleLink, _objectSpread(_objectSpread({
        className: className,
        as: "button",
        "aria-labelledby": headingId
      }, titleLinkProps), {}, {
        onClick: onClick,
        children: /*#__PURE__*/jsx(Title$2, _objectSpread(_objectSpread({}, rest), {}, {
          "aria-hidden": "true",
          children: children
        }))
      }))]
    });
  }
  var titleProps = headingLevel ? _objectSpread({
    as: headingTag
  }, rest) : rest;
  var title = /*#__PURE__*/jsx(Title$2, _objectSpread(_objectSpread({}, titleProps), {}, {
    children: children
  }));
  if (url && onClick) {
    return /*#__PURE__*/jsx(TitleLink, {
      className: className,
      href: url,
      onClick: onClick,
      children: title
    });
  }
  if (url) {
    return /*#__PURE__*/jsx(TitleLink, {
      className: className,
      href: url,
      children: title
    });
  }
  if (onClick) {
    return /*#__PURE__*/jsx(TitleLink, _objectSpread(_objectSpread({
      className: className,
      as: "button"
    }, titleLinkProps), {}, {
      onClick: onClick,
      children: title
    }));
  }
  return title;
};
var Title$1 = Title;

export { Title$1 as default };
//# sourceMappingURL=Title.js.map
